import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import PersonalDataWizardStep from './steps/PersonalDataWizardStep.vue';
import CustomerMembershipWizardStep from './steps/CustomerMembershipWizardStep.vue';
import ConsolesWizardStep from './steps/ConsolesWizardStep.vue';
import PermissionsWizardStep from './steps/PermissionsWizardStep.vue';
import SummaryWizardStep from './steps/SummaryWizardStep.vue';
import { User } from '@/models/user';
import { Customer } from '@/models/tenant';
import { computed, ref } from 'vue';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { useUserWizard } from './user-wizard-utils';
import { isNil } from '@/utils/misc';
import { customersService } from '@/services/tenants.service';
import { areArraysEqual } from '@/utils/array';
import { dialogService } from '@/library-services/dialog.service';
import { currentUser, hasCurrentUserPermission } from '@/utils/permissionUtils';
import { UserType } from '@/models/userType';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CustomerUserWizard',
  props: {
    user: { default: null },
    customer: { default: null }
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { user: User | null, customer: Customer | null };





const { t } = useI18n();

const customerCopy = ref<Customer | null>(null);
const originalConsoles = ref<ConsoleEnum[]>([]);
const originalLocations = ref<number[]>([]);
const isCustomerLoading = ref(false);

const {
  userCopy,
  submit: applyChanges,
  isEdit,
} = useUserWizard(props, emit, User.empty(), async () => {
  customerCopy.value = props.customer;

  if (isEdit.value) {
    originalConsoles.value = userCopy.value!.consoles;
    originalLocations.value = userCopy.value!.locations;

    if (isOpenedFromUsersPage.value) {
      await loadCustomer();
    }
  } else if (isOpenedFromCustomerUsersList.value) {
    userCopy.value!.customerId = props.customer!.id;
    userCopy.value!.tenantName = props.customer!.name;
  }
});

async function onSubmit() {
  if (isDashboardResetNeeded.value) {
    dialogService.confirmWithPromise({
      title: t('dialog.confirm_title').toString(),
      message: t('user.update').toString(),
      confirmText: t('dialog.confirm_save').toString(),
      cancelText: t(`dialog.confirm_cancel`).toString(),
      type: 'is-primary',
      onConfirm: async () => await applyChanges(authorizedConsoles.value),
    });
  } else {
    await applyChanges(authorizedConsoles.value);
  }
}

async function loadCustomer() {
  if (customerCopy.value?.id === userCopy.value?.customerId) {
    return;
  }
  isCustomerLoading.value = true;
  try {
    customerCopy.value = await customersService.getById(
      userCopy.value!.customerId,
    );
  } finally {
    isCustomerLoading.value = false;
  }
}

function onLeaveCustomerMembershipWizardStep(toPreviousPage: boolean) {
  if (!toPreviousPage) {
    loadCustomer();
  }
}

const authorizedConsoles = computed(() => {
  const consoles = [];
  if (customerCopy.value?.hasDatahub) {
    consoles.push(ConsoleEnum.WCC);
  }
  if (customerCopy.value?.hasSmbs && currentUser().isGlobalAdmin) {
    consoles.push(ConsoleEnum.BC, ConsoleEnum.SFC);
  }
  return consoles;
});

const isDashboardResetNeeded = computed(() => {
  if (!isEdit.value) {
    return false;
  }
  return (
    !areArraysEqual(userCopy.value!.consoles, originalConsoles.value) ||
    !areArraysEqual(userCopy.value!.locations, originalLocations.value)
  );
});

/**
 * Only show when a new user is being created from the Users view
 */
const shouldHideMembershipStep = computed(
  () => isEdit.value || isOpenedFromCustomerUsersList.value,
);

/**
 * Do not show when a Customer Admin is editing another Customer Admin/User
 */
const shouldHideConsoleStep = computed(
  () => isEdit.value && !hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

/**
 * Do not show to Customer Users
 */
const shouldHidePermissionsStep = computed(
  () => !hasCurrentUserPermission(UserType.CustomerAdmin),
);

const isOpenedFromUsersPage = computed(
  () => !isOpenedFromCustomerUsersList.value,
);

const isOpenedFromCustomerUsersList = computed(() => !isNil(props.customer));

return { __sfc: true,props, emit, t, customerCopy, originalConsoles, originalLocations, isCustomerLoading, userCopy, applyChanges, isEdit, onSubmit, loadCustomer, onLeaveCustomerMembershipWizardStep, authorizedConsoles, isDashboardResetNeeded, shouldHideMembershipStep, shouldHideConsoleStep, shouldHidePermissionsStep, isOpenedFromUsersPage, isOpenedFromCustomerUsersList, Wizard, PersonalDataWizardStep, CustomerMembershipWizardStep, ConsolesWizardStep, PermissionsWizardStep, SummaryWizardStep }
}

})